import { borderRadiusMedium, colorNeutralBackground1, colorTransparentStrokeInteractive, display, fontFamilyBase, shadow8, spacingHorizontalL, spacingHorizontalM, spacingHorizontalXL, spacingVerticalL, spacingVerticalM } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${display("block")}

  :host([mode="auto"]) .popover-overlay {
    position: fixed;
    inset: 0;
    z-index: 0;
    display: none;
    background-color: transparent;
    width: 100vw;
    height: 100vh;
  }

  :host([mode="auto"]) .popover-overlay.overlay-open {
    display: block;
  }

  .popover-container {
    position: relative;
    width: fit-content;
  }

  .popover {
    font-family: ${fontFamilyBase};
    background-color: ${colorNeutralBackground1};
    border-radius: ${borderRadiusMedium};
    border: 1px solid ${colorTransparentStrokeInteractive};
    box-shadow: ${shadow8};

    visibility: hidden;
    opacity: 0;
    z-index: 0;
    position: absolute;
    inset: 0;

    margin: 0;
    min-width: 50px; /* @design-token-ok */
    min-height: 68px; /* @design-token-ok */
    max-width: var(--popoverMaxWidth, 260px);

    width: max-content;
    height: max-content;
    padding: ${spacingHorizontalL};

    transition: all var(--popoverTransition, 0ms);
    transition-delay: var(--popoverTransitionDelay, 0ms);
  }

  .popover.popover-open {
    visibility: visible;
    display: block;
    opacity: 1;
    z-index: 1000;
  }

  :host([size="small"]) .popover {
    padding: ${spacingHorizontalM};
    max-width: var(--popoverMaxWidth, 214px);
  }

  :host([size="large"]) .popover {
    padding: ${spacingHorizontalXL};
    max-width: var(--popoverMaxWidth, 317px);
  }

  .beak {
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
    border-inline-start: 8px solid transparent;
    border-inline-end: 8px solid transparent;
    border-bottom: 8px solid ${colorNeutralBackground1};
    z-index: 1;
  }

  :host([beak]) .beak-shadow::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-inline-start: 8px solid transparent;
    border-inline-end: 9px solid transparent;
    border-bottom: 8px solid rgba(0, 0, 0, 0.14); /* @design-token-ok */
    filter: blur(8px);
    z-index: 0;

    opacity: 0;
    transition: all var(--popoverTransition, 0ms);
    transition-delay: var(--popoverTransitionDelay, 0ms);
  }

  :host([open][beak]) .beak-shadow:after {
    opacity: 1;
  }

  :host([position="above-start"]) .popover {
    inset-inline-start: calc(0% + var(--popoverHorizontalNudge, 0px));
    top: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(0%, -90%);
  }
  :host([position="above-start"]) .popover.popover-open {
    transform: translate(0%, -100%);
  }

  :host([position="above-start"][beak]) .popover.popover-open {
    /* popover  */
    top: -12px; /* @design-token-ok */ /* offset popover from anchor  */
  }

  :host([position="above-start"][beak]) .beak-shadow:after {
    /* beak drop shadow */
    inset-inline-start: calc(
      ${spacingHorizontalL} + var(--beakShadowHorizontalNudge, 0px)
    );
    top: calc(
      -8px + var(--beakShadowVerticalNudge)
    ); /* offset dropshadow from anchor  */
    transform: rotate(180deg);
    filter: blur(4px);
  }

  :host([position="above-start"][beak]) .beak {
    /* beak  */
    inset-inline-start: ${spacingHorizontalL};
    top: 100%;
    transform: rotate(180deg);
  }

  :host([position="above-center"]) .popover {
    inset-inline-start: calc(50% + var(--popoverHorizontalNudge, 0px));
    top: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-50%, -90%);
  }
  :host([position="above-center"]) .popover.popover-open {
    transform: translate(-50%, -100%);
  }

  :host([position="above-center"][beak]) .popover.popover-open {
    transform: translate(-50%, -100%);
    top: -12px; /* @design-token-ok */
  }

  :host([position="above-center"][beak]) .beak-shadow:after {
    inset-inline-start: calc(50% - 8px + var(--beakShadowHorizontalNudge, 0px));
    top: calc(-8px + var(--beakShadowVerticalNudge, 0px));
    transform: rotate(180deg);
  }

  :host([position="above-center"][beak]) .beak {
    inset-inline-start: calc(50% - 8px);
    top: 100%;
    transform: rotate(180deg);
  }

  :host([position="above-end"]) .popover {
    inset-inline-start: calc(100% + var(--popoverHorizontalNudge, 0px));
    top: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-100%, -90%);
  }
  :host([position="above-end"]) .popover.popover-open {
    transform: translate(-100%, -100%);
  }

  :host([position="above-end"][beak]) .popover.popover-open {
    transform: translate(-100%, -100%);
    top: -12px; /* @design-token-ok */
  }

  :host([position="above-end"][beak]) .beak-shadow:after {
    inset-inline-end: calc(
      ${spacingHorizontalL} + var(--beakShadowHorizontalNudge, 0px)
    );
    top: calc(-8px + var(--beakShadowVerticalNudge, 0px));
    transform: rotate(180deg);
  }

  :host([position="above-end"][beak]) .beak {
    inset-inline-end: ${spacingHorizontalL};
    top: 100%;
    transform: rotate(180deg);
  }

  :host([position="end-top"]) .popover {
    inset-inline-start: calc(100% + var(--popoverHorizontalNudge, 0px));
    top: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-10%, 0%);
  }
  :host([position="end-top"]) .popover.popover-open {
    transform: translate(0%, 0%);
  }
  :host([position="end-top"][beak]) .popover.popover-open {
    inset-inline-start: calc(100% + ${spacingHorizontalM});
  }

  :host([position="end-top"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      100% - 1px + var(--beakShadowHorizontalNudge, 0px)
    );
    top: calc(18px + var(--beakShadowVerticalNudge, 0px));
    transform: rotate(270deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.07); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="end-top"][beak]) .beak {
    inset-inline-start: -12px; /* @design-token-ok */
    top: ${spacingVerticalL};
    transform: rotate(270deg);
  }

  :host([position="end-middle"]) .popover {
    inset-inline-start: calc(100% + var(--popoverHorizontalNudge, 0px));
    top: calc(50% + var(--popoverVerticalNudge, 0px));
    transform: translate(-10%, -50%);
  }
  :host([position="end-middle"]) .popover.popover-open {
    transform: translate(0%, -50%);
  }

  :host([position="end-middle"][beak]) .popover.popover-open {
    inset-inline-start: calc(100% + ${spacingHorizontalM});
  }

  :host([position="end-middle"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      100% - 1px + var(--beakShadowHorizontalNudge, 0px)
    );
    top: calc(50% - 2px + var(--beakShadowVerticalNudge, 0px));
    transform: rotate(270deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.11); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="end-middle"][beak]) .beak {
    inset-inline-start: -12px; /* @design-token-ok */
    top: calc(50% - 4px);
    transform: rotate(270deg);
  }

  :host([position="end-bottom"]) .popover {
    inset-inline-start: calc(100% + var(--popoverHorizontalNudge, 0px));
    top: unset;
    bottom: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-10%, 0%);
  }
  :host([position="end-bottom"]) .popover.popover-open {
    transform: translate(0%, 0%);
  }

  :host([position="end-bottom"][beak]) .popover.popover-open {
    inset-inline-start: calc(100% + ${spacingHorizontalM});
  }

  :host([position="end-bottom"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      100% - 1px + var(--beakShadowHorizontalNudge, 0px)
    );
    top: unset;
    bottom: calc(
      17px + var(--beakShadowVerticalNudge, 0px)
    ); /* @design-token-ok */
    transform: rotate(270deg);
    filter: blur(3px);
  }

  :host([position="end-bottom"][beak]) .beak {
    inset-inline-start: -12px; /* @design-token-ok */
    top: unset;
    bottom: ${spacingVerticalL};
    transform: rotate(270deg);
  }

  :host([position="below-start"]) .popover {
    inset-inline-start: calc(0% + var(--popoverHorizontalNudge, 0px));
    top: calc(100% + var(--popoverVerticalNudge, 0px));
    transform: translate(0%, -10%);
  }
  :host([position="below-start"]) .popover.popover-open {
    transform: translate(0%, 0%);
  }

  :host([position="below-start"][beak]) .popover.popover-open {
    top: calc(100% + ${spacingVerticalM});
  }

  :host([position="below-start"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      ${spacingHorizontalL} + var(--beakShadowHorizontalNudge, 0px)
    );
    top: unset;
    bottom: -12px; /* @design-token-ok */
    transform: rotate(0deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.07); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="below-start"][beak]) .beak {
    inset-inline-start: ${spacingHorizontalL};
    top: -8px;
    transform: rotate(0deg);
  }

  :host([position="below-center"]) .popover {
    inset-inline-start: calc(50% + var(--popoverHorizontalNudge, 0px));
    top: calc(100% + var(--popoverVerticalNudge, 0px));
    transform: translate(-50%, -10%);
  }
  :host([position="below-center"]) .popover.popover-open {
    transform: translate(-50%, 0%);
  }

  :host([position="below-center"][beak]) .popover.popover-open {
    top: calc(100% + 8px);
  }

  :host([position="below-center"][beak]) .beak-shadow:after {
    inset-inline-start: calc(50% - 8px + var(--beakShadowHorizontalNudge, 0px));
    top: unset;
    bottom: -8px;
    transform: rotate(0deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.07); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="below-center"][beak]) .beak {
    inset-inline-start: calc(50% - 8px);
    top: -8px;
    transform: rotate(0deg);
  }

  :host([position="below-end"]) .popover {
    inset-inline-start: calc(100% + var(--popoverHorizontalNudge, 0px));
    top: calc(100% + var(--popoverVerticalNudge, 0px));
    transform: translate(-100%, -10%);
  }
  :host([position="below-end"]) .popover.popover-open {
    transform: translate(-100%, 0%);
  }

  :host([position="below-end"][beak]) .popover.popover-open {
    top: calc(100% + ${spacingVerticalM});
  }

  :host([position="below-end"][beak]) .beak-shadow:after {
    inset-inline-end: calc(
      ${spacingHorizontalL} + var(--beakShadowHorizontalNudge, 0px)
    );
    top: unset;
    bottom: -12px; /* @design-token-ok */
    transform: rotate(0deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.07); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="below-end"][beak]) .beak {
    inset-inline-end: ${spacingHorizontalL};
    top: -8px;
    transform: rotate(0deg);
  }

  :host([position="start-top"]) .popover {
    inset-inline-start: calc(0% + var(--popoverHorizontalNudge, 0px));
    top: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-90%, 0%);
  }
  :host([position="start-top"]) .popover.popover-open {
    transform: translate(-100%, 0%);
  }

  :host([position="start-top"][beak]) .popover.popover-open {
    inset-inline-start: -12px; /* @design-token-ok */
  }

  :host([position="start-top"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      -15px + var(--beakShadowHorizontalNudge, 0px)
    ); /* @design-token-ok */
    top: calc(
      18px + var(--beakShadowVerticalNudge, 0px)
    ); /* @design-token-ok */
    transform: rotate(90deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.07); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="start-top"][beak]) .beak {
    inset-inline-end: -12px; /* @design-token-ok */
    top: ${spacingVerticalL};
    transform: rotate(90deg);
  }

  :host([position="start-middle"]) .popover {
    inset-inline-start: calc(0% + var(--popoverHorizontalNudge, 0px));
    top: calc(50% + var(--popoverVerticalNudge, 0px));
    transform: translate(-90%, -50%);
  }

  :host([position="start-middle"]) .popover.popover-open {
    transform: translate(-100%, -50%);
  }

  :host([position="start-middle"][beak]) .popover.popover-open {
    inset-inline-start: -12px; /* @design-token-ok */
  }

  :host([position="start-middle"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      -15px + var(--beakShadowHorizontalNudge, 0px)
    ); /* @design-token-ok */
    top: calc(50% - 2px + var(--beakShadowVerticalNudge, 0px));
    transform: rotate(90deg);
    border-bottom: 8px solid rgba(0, 0, 0, 0.11); /* @design-token-ok */
    filter: blur(2px);
  }

  :host([position="start-middle"][beak]) .beak {
    inset-inline-end: -12px; /* @design-token-ok */
    top: calc(50% - 4px);
    transform: rotate(90deg);
  }

  :host([position="start-bottom"]) .popover {
    inset-inline-start: calc(0% + var(--popoverHorizontalNudge, 0px));
    top: unset;
    bottom: calc(0% + var(--popoverVerticalNudge, 0px));
    transform: translate(-90%, 0%);
  }
  :host([position="start-bottom"]) .popover.popover-open {
    transform: translate(-100%, 0%);
  }

  :host([position="start-bottom"][beak]) .popover.popover-open {
    inset-inline-start: -12px; /* @design-token-ok */
  }

  :host([position="start-bottom"][beak]) .beak-shadow:after {
    inset-inline-start: calc(
      -15px + var(--beakShadowHorizontalNudge, 0px)
    ); /* @design-token-ok */
    top: unset;
    bottom: calc(
      17px + var(--beakShadowVerticalNudge, 0px)
    ); /* @design-token-ok */
    transform: rotate(90deg);
    filter: blur(3px);
  }

  :host([position="start-bottom"][beak]) .beak {
    inset-inline-end: -12px; /* @design-token-ok */
    top: unset;
    bottom: ${spacingVerticalL};
    transform: rotate(90deg);
  }
`;
//# sourceMappingURL=popover.styles.js.map